import React from 'react';
import PropTypes from "prop-types";

export default function MyGyms(props) {
	return (
		<div>
			<h5>My Gyms</h5>

			<blockquote>
				{props.defenders.map(gym => <div key={gym.id}><button onClick={() => props.removeDefender(gym.id)}>Remove</button> <b>{gym.name}</b> ({gym.dst.toFixed(1)} mi)</div>)}
			</blockquote>

			<button onClick={props.clearDefenders}>Remove All</button>
		</div>
	);
};

MyGyms.propTypes = {
	defenders: PropTypes.array.isRequired,
	removeDefender: PropTypes.func.isRequired,
	clearDefenders: PropTypes.func.isRequired,
};